export { default as CVStepAutoApplySchema } from './cVStepAutoApply.schema'
export { default as CVStepEducationSchema } from './cVStepEducation.schema'
export { default as CVStepLanguagesSchema } from './cVStepLanguages.schema'
export { default as CVStepPersonalInformationSchema } from './cVStepPersonalInformation.schema'
export { default as CVStepPersonalPhotoSchema } from './cVStepPersonalPhoto.schema'
export { default as CVStepPreferencesSchema } from './cVStepPreferences.schema'
export { default as CVStepPrivacyPolicySchema } from './cVStepPrivacyPolicy.schema'
export { default as CVStepUploadFileSchema } from './cVStepUploadFile.schema'
export {
  default as CVStepWorkExperienceSchema,
  CVStepWorkIndustriesSchema
} from './cVStepWorkExperience.schema'
